var _circle, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451.277 451.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#2a404f",
    cx: 225.638,
    cy: 225.638,
    r: 225.638
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M352.857 183.414c-.799-1.222-1.881-2.257-3.056-3.055l-28.254-28.207-.376-.424c-.235-.283-.47-.517-.752-.752-2.069-1.928-4.889-3.104-7.945-3.104H198.046l-19.51-19.51c-2.164-2.477-5.338-4.091-8.885-4.091h-61.492c-6.535 0-11.8 5.265-11.8 11.8v179.163c0 3.667 1.739 7.052 4.513 9.214L227.7 451.244c106.335-.957 195.049-75.443 217.849-175.091l-92.598-92.599z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6C358",
    d: "M181.452 136.062c0-6.514-5.281-11.796-11.796-11.796h-61.505c-6.514 0-11.796 5.281-11.796 11.796v179.152c0 6.514 5.281 11.796 11.796 11.796h204.314c6.514 0 11.796-5.281 11.796-11.796v-155.56c0-6.514-5.281-11.796-11.796-11.796H193.248c-6.515 0-11.796-5.281-11.796-11.796z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD462",
    d: "M343.12 178.273H139.536c-5.41 0-10.126 3.68-11.442 8.927L96.715 312.345c-1.867 7.447 3.764 14.665 11.441 14.665H311.74c5.41 0 10.126-3.68 11.442-8.927l31.379-125.146c1.868-7.446-3.764-14.664-11.441-14.664z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M197.102 269.816h-65.035c-2.242 0-4.059 1.909-4.059 4.262v34.417c0 2.354 1.817 4.262 4.059 4.262h65.035c2.242 0 4.06-1.908 4.06-4.262v-34.417c0-2.354-1.818-4.262-4.06-4.262z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EBF0F3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.491 276.357h58.184v4.7h-58.184zM135.491 288.922h58.184v4.7h-58.184zM135.491 301.512h58.184v4.7h-58.184z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.1a41d07292a3a6fd9451aace2e2c5f37.svg";
export { ForwardRef as ReactComponent };